'use client';

import * as React from 'react';
import ReactDOM from 'react-dom';
import { getCoverImageTheme } from 'app/blog/[domain]/_components/cover-image-theme';
import { extractCoverImageAtom } from 'app/blog/[domain]/_components/design-state';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

export type CoverImageProps = {
  src: string;
};

export function CoverImage({ src }: CoverImageProps): JSX.Element {
  const t = useTranslations('Blog.Post.Header');
  const extractCoverImage = useAtomValue(extractCoverImageAtom);
  if (!extractCoverImage) {
    return <></>;
  }
  ReactDOM.preload(src, {
    as: 'image',
    fetchPriority: 'high',
  });
  return (
    <img
      alt={t('CoverImage')}
      className="post-header-cover"
      data-theme-cover={getCoverImageTheme(src)}
      src={src}
    />
  );
}
